// src/pages/AdolescentCare.jsx
import React from 'react';

function AdolescentCare() {
  return (
    <div className="container my-5">
      <h1 className="text-center mb-5">Adolescent Sexual Health Package</h1>

      <div className="card mb-4">
        <div className="card-header bg-danger text-white">
          <h3>Sexual Health Education</h3>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <h5>Key Topics</h5>
              <ul>
                <li>Consent and boundaries</li>
                <li>Contraception methods</li>
                <li>STI prevention</li>
                <li>Healthy relationships</li>
              </ul>
            </div>
            <div className="col-md-6">
              <h5>Common Questions</h5>
              <div className="accordion">
                <div className="accordion-item">
                  <h6 className="accordion-header">
                    <button className="accordion-button">How do I know if I'm ready?</button>
                  </h6>
                  <div className="accordion-collapse">
                    <div className="accordion-body">
                      Consider emotional readiness and ability to handle consequences
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h6 className="accordion-header">
                    <button className="accordion-button">Signs of healthy relationships?</button>
                  </h6>
                  <div className="accordion-collapse">
                    <div className="accordion-body">
                      Mutual respect, trust, and open communication
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header bg-danger text-white">
          <h3>Support Services</h3>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <h5>Health Services</h5>
              <ul>
                <li>Confidential STI testing</li>
                <li>Contraception counseling</li>
                <li>Mental health support</li>
              </ul>
            </div>
            <div className="col-md-6">
              <h5>Resources</h5>
              <ul>
                <li>24/7 helpline</li>
                <li>School workshops</li>
                <li>Online chat support</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdolescentCare;